<template>
  <div class="d-flex align-items-center">
    <div class="flex-grow-1 d-flex flex-column">
      <div>{{ name }}</div>
    </div>
    <div class="flex-shrink-0">
      <el-popover
          placement="top-end"
          width="300"
          trigger="click"
      >
        <div class="word-break-normal">{{ description }}</div>
        <button slot="reference" class="btn btn-secondary btn-sm">
          <i class="fas fa-info fa-fw"></i>
        </button>
      </el-popover>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    row: Object,
  },

  computed: {
    /**
     * @return {string}
     */
    name() {
      return _.get(this.row, 'name', '');
    },

    /**
     * @return {string}
     */
    description() {
      return _.get(this.row, 'description', 'Empty');
    },
  },
}
</script>
